
import xorWith from 'lodash/xorWith';
import isEqual from 'lodash/isEqual';

import {
  TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP,
  CLEAR_SUPER_LOTTERY_SLIP,
  SET_SUPER_LOTTERYSLIP_FROM_LOCAL_STORAGE
} from 'Store/constants';
import { LOTTERY_MULTIPLIERS } from 'Store/constants/sportTypes';

const initialState = {
  tickets: [],
  buy: {
    serialCodes: [],
    ticketIds: []
  },
  calculations: {
    totalAmount: 0,
    quarter: {
      piece: 0,
      amount: 0
    },
    half: {
      piece: 0,
      amount: 0
    },
    full: {
      piece: 0,
      amount: 0
    }
  }
};

const getTicketIds = tickets => {
  let ticketIds = [];
  let serialCodes = [];

  for (let i = 0; i < tickets.length; i++) {
    if (tickets[i].ticketId && tickets[i].serialType === null) {
      ticketIds.push(tickets[i].ticketId.toString());
    } else {
      serialCodes.push(tickets[i].serialCode?.toString());
    }
  }

  return {
    ticketIds,
    serialCodes
  };
};

const getCalculations = tickets => {
  let totalAmount = 0;
  let pieceQuarter = 0;
  let amountQuarter = 0;
  let pieceHalf = 0;
  let amountHalf = 0;
  let pieceFull = 0;
  let amountFull = 0;
  
  for (let i = 0; i < tickets.length; i++ ) {
    if (tickets[i].serialType) {

      totalAmount += LOTTERY_MULTIPLIERS[tickets[i].serialType] * +tickets[i].ticketPrice;

    } else {

      totalAmount += +tickets[i].ticketPrice;
    }

    if (tickets[i].ticketType === 'QUARTER') {
      if (tickets[i].serialType) {

        pieceQuarter += LOTTERY_MULTIPLIERS[tickets[i].serialType];
        amountQuarter += LOTTERY_MULTIPLIERS[tickets[i].serialType] * +tickets[i].ticketPrice;

      } else {

        pieceQuarter += 1;
        amountQuarter += +tickets[i].ticketPrice;
      }
    }

    if (tickets[i].ticketType === 'HALF') {
      if (tickets[i].serialType) {

        pieceHalf += LOTTERY_MULTIPLIERS[tickets[i].serialType];
        amountHalf += LOTTERY_MULTIPLIERS[tickets[i].serialType] * +tickets[i].ticketPrice;

      } else {

        pieceHalf += 1;
        amountHalf += +tickets[i].ticketPrice;
      }
    }

    if (tickets[i].ticketType === 'FULL') {
      if (tickets[i].serialType) {

        pieceFull += LOTTERY_MULTIPLIERS[tickets[i].serialType];
        amountFull += LOTTERY_MULTIPLIERS[tickets[i].serialType] * +tickets[i].ticketPrice;

      } else {

        pieceFull += 1;
        amountFull += +tickets[i].ticketPrice;
      }
    }
  }

  return  {
    totalAmount: totalAmount,
    quarter: {
      piece: pieceQuarter,
      amount: amountQuarter
    },
    half: {
      piece: pieceHalf,
      amount: amountHalf
    },
    full: {
      piece: pieceFull,
      amount: amountFull
    }
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP: {

      const updatedTickets = xorWith(state.tickets, [action.payload], isEqual) || [];
      
      return {
        ...state,
        tickets: updatedTickets,
        calculations: getCalculations(updatedTickets),
        buy: getTicketIds(updatedTickets)
      };
    }

    case CLEAR_SUPER_LOTTERY_SLIP: {
      return initialState;
    }

    case SET_SUPER_LOTTERYSLIP_FROM_LOCAL_STORAGE:
      return action.payload?.lotterySlip || initialState;
    
    default:
      return state;
  }
};
